module.exports = __webpack_public_path__ + "static/media/sms-sent.476201ad.svg";